import { render } from "./fbx-input.vue?vue&type=template&id=9b2eb722&scoped=true"
import script from "./fbx-input.vue?vue&type=script&lang=js"
export * from "./fbx-input.vue?vue&type=script&lang=js"

import "./fbx-input.vue?vue&type=style&index=0&id=9b2eb722&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b2eb722"]])

export default __exports__